export default "__VITE_ASSET__CS6gwpUC__"